import { currentMonth, platformKeys } from "./constants";

export function getContainerMaxHeight({ setMaxContainerHeight }: any) {
  const containerEl = document.getElementById("revenue-container");
  const windowHeight = window.innerHeight;

  if (containerEl) {
    const offsets = containerEl.getBoundingClientRect();
    setMaxContainerHeight(windowHeight - offsets?.top - 12);
  }
}

export function calculateContainerProperties({ screens }: any) {
  const { top = 0 } =
    document.getElementById("revenue-container")?.getBoundingClientRect() || {};

  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  const maxContainerHeight = windowHeight - top - 20;

  const gap = maxContainerHeight * 0.02;
  // divided into 7 rows 3 for each graph row and 1 for revenue cards
  let oneRowHeight = (maxContainerHeight - gap * 2) / 7;

  if (oneRowHeight > 100) {
    oneRowHeight = !screens.lg ? 80 : 100;
  }

  if (!oneRowHeight) {
    oneRowHeight = 80;
  }

  return {
    maxHeight: maxContainerHeight,
    gap,
    rowHeight: oneRowHeight < 80 ? 80 : oneRowHeight,
    isSm: windowWidth < 1080,
  };
}

export function getEarlyRevenue({ revenuYearlyGraph, activePlateform }: any) {
  return revenuYearlyGraph?.data?.[platformKeys[activePlateform]]?.slice(
    0,
    currentMonth + 1,
  );
}

export function getTotalEarned(data: any) {
  return data?.[currentMonth]?.total_amount || 0;
}
